import React, { useEffect, useState } from "react";
import styles from "./statistics-overview.module.css";
import StatisticsCard from "../../../../components/statistics-card/statistics-card";
import { toast } from "react-toastify";
import { getTeacherStats } from "../../../../services/teachers";

const TeachersStatisticsOverview = () => {
  const [overviewStatistics, setOverviewStatistics] = useState({});

  const fetchTeacherStatistics = async () => {
    try {
      const resp = await getTeacherStats();
      const data = resp.data?.data;
      const buildObject = {
        total_male_teachers: data?.maleTotalTeachers,
        total_female_teachers: data?.femaleTotalTeachers,
        total_teachers: data?.totalTeachers,
        total_teachers_present: data?.teachersPresent,
        total_subjects: data?.totalSubjects,
        total_classes: data?.totalClasses,
      };
      setOverviewStatistics(buildObject);
    } catch (err) {
      toast.error("Error Retrieving Stats");
    }
  };

  useEffect(() => {
    fetchTeacherStatistics();
  }, []);

  const overview_statistics = [
    {
      icon_name: "users-icon",
      icon_fill: "transparent",
      icon_stroke: "#ffffff",
      icon_width: "24px",
      icon_height: "24px",
      heading_text: "Total Teachers",
      card_bg_color: "rgba(234, 236, 240, 1)",
      icon_container_bg_color: "rgba(224, 90, 33, 1)",
      statistic_value: overviewStatistics?.total_teachers ?? "-",
    },
    {
      icon_name: "male",
      icon_fill: "transparent",
      icon_stroke: "transparent",
      icon_width: "24px",
      icon_height: "24px",
      heading_text: "Male Teachers",
      card_bg_color: "rgba(233, 243, 255, 1)",
      icon_container_bg_color: "rgba(86, 155, 246, 1)",
      statistic_value: overviewStatistics?.total_male_teachers ?? "-",
    },
    {
      icon_name: "female",
      icon_fill: "transparent",
      icon_stroke: "#ffffff",
      icon_width: "24px",
      icon_height: "24px",
      heading_text: "Female Teachers",
      card_bg_color: "rgba(245, 240, 255, 1)",
      icon_container_bg_color: "rgba(127, 86, 217, 1)",
      statistic_value: overviewStatistics?.total_female_teachers ?? "-",
    },
    {
      icon_name: "pie-chart",
      icon_fill: "transparent",
      icon_stroke: "#ffffff",
      icon_width: "24px",
      icon_height: "24px",
      heading_text: "Teachers Present",
      card_bg_color: "rgba(255, 251, 233, 1)",
      icon_container_bg_color: "rgba(235, 206, 61, 1)",
      statistic_value: overviewStatistics?.total_teachers_present ?? "-",
    },
    {
      icon_name: "book-closed",
      icon_fill: "transparent",
      icon_stroke: "#ffffff",
      icon_width: "24px",
      icon_height: "24px",
      heading_text: "Total Subjects",
      card_bg_color: "rgba(242, 255, 244, 1)",
      icon_container_bg_color: "rgba(41, 194, 65, 1)",
      statistic_value: overviewStatistics?.total_subjects ?? "-",
    },
    {
      icon_name: "clipboard",
      icon_fill: "transparent",
      icon_stroke: "#ffffff",
      icon_width: "24px",
      icon_height: "24px",
      heading_text: "Total Classes",
      card_bg_color: "rgba(231, 248, 255, 1)",
      icon_container_bg_color: "rgba(75, 202, 255, 1)",
      statistic_value: overviewStatistics?.total_classes ?? "-",
    },
  ];

  return (
    <div className={styles.statistics_overview}>
      <div className={styles.statistics}>
        {overview_statistics?.map(
          ({
            icon_name,
            icon_fill,
            icon_stroke,
            icon_width,
            icon_height,
            heading_text,
            card_bg_color,
            icon_container_bg_color,
            statistic_value,
          }) => (
            <div className={styles.statistics_card}>
              <StatisticsCard
                icon_name={icon_name}
                icon_fill={icon_fill}
                icon_stroke={icon_stroke}
                icon_width={icon_width}
                icon_height={icon_height}
                heading_text={heading_text}
                card_bg_color={card_bg_color}
                icon_container_bg_color={icon_container_bg_color}
                statistic_value={statistic_value}
              />
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default TeachersStatisticsOverview;
